import styled from 'styled-components'

// Icons
import { ReactComponent as CrossIcon } from 'icons/cross-16.svg'

// Components
import { ButtonUnstyled } from 'components/Button'

export const StyledCrossIcon = styled(CrossIcon)`
  width: 16px;
  height: 16px;
`

export const CloseButton = styled(ButtonUnstyled)`
  align-self: center;
  display: flex;
  opacity: 0.4;

  :hover {
    opacity: 0.85;
  }
`

export const Container = styled.section`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.dark.extraHigh};
  /*
    TODO: Refactor to theme shadow when #6521 is merged
    https://github.com/sketch-hq/Cloud/issues/6521
  */
  box-shadow: 0 7px 25px 0 ${({ theme }) => theme.colors.border.dark.high};
  z-index: 1;
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.background.light.secondary};
  border-radius: ${({ theme }) => `
    ${theme.radii.medium} ${theme.radii.medium} 0px 0px
  `};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};
`

export const Title = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: -0.07px;
  line-height: 1.75;
`

export const Content = styled.div`
  padding: 16px;
`
